import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { cardTitle } from "assets/jss/material-dashboard-pro-react.js";

import { Create, Add } from "@material-ui/icons";

import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardIcon from "components/Card/CardIcon.js";
import CardHeader from "components/Card/CardHeader.js";
import ReactTable from "components/ReactTable/ReactTable.js";
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

import { wsGetAll } from "services/WService.js";

import ModalCompany from "./ModalCompany";
import { Toasty, useToasty } from "hooks/Toasty";
import ButtonDelete from "hooks/ButtonDelete";
import { useModal } from "hooks/useModal";
import { WithApp } from "contexts/appContext";

const useStyles = makeStyles({
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  }
});

const columns = [
  { Header: "#", accessor: "num", excelEnabled: false },
  { Header: "Nombre", accessor: "compnyName" },
  { Header: "RUC", accessor: "taxIdNum" },
  { Header: "Dirección", accessor: "compnyAddr" },
  { Header: "País", accessor: "country" },
  { Header: "Ubigeo", accessor: "ubigeo" },
  { Header: "Registro MTC", accessor: "mtc_registration" },
  { Header: "", accessor: "actions" }
];

export default WithApp(function Company(props) {
  const classes = useStyles();

  const [model, setOpen] = useModal();
  const [notify, showNotify] = useToasty();

  const [companies, setCompanies] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);

  async function loadCompanies() {
    setDataLoading(true);
    let response = await wsGetAll("base/company");
    setDataLoading(false);
    if (response.success) setCompanies(response.data);
  }

  useEffect(() => {
    loadCompanies();
  }, []);

  return (
    <GridContainer>
      <Toasty action={notify} />

      <ModalCompany
        model={model}
        setOpen={setOpen}
        showNotify={showNotify}
        reload={loadCompanies}
      />

      <GridItem xs={12}>
        <Card>
          <CardHeader icon>
            <CardIcon
              onClick={() => setOpen({})}
              color={props.themeContext.buttonColorSuccess}
              pointer="true"
            >
              <Add />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>Empresas {dataLoading && <LoadingSpinner />}</h4>
          </CardHeader>
          <CardBody>
            <ReactTable
              excelName="Empresas"
              columns={columns}
              data={companies.map((company, i) => {
                return {
                  num: (
                    <div className="actions-right">
                      {i + 1}
                      <Button
                        justIcon
                        round
                        simple
                        color="info"
                        className="like"
                        onClick={() => setOpen(company)}
                      >
                        <Create />
                      </Button>
                      <ButtonDelete
                        entity="base/company"
                        id={company.id}
                        reload={loadCompanies}
                      />
                    </div>
                  ),
                  compnyName: company.compnyName,
                  taxIdNum: company.taxIdNum,
                  compnyAddr: company.compnyAddr,
                  country: company.country,
                  ubigeo: company.ubigeo
                    ? `${company.ubigeo.U_SYP_DEPA}, ${company.ubigeo.U_SYP_PROV}, ${company.ubigeo.U_SYP_DIST}`
                    : '-',
                  mtc_registration: company.mtc_registration,
                  actions: ""
                };
              })}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
});
